type TimeSeriesAreaPathsProps = {
  areaPath: string;
  linePath: string;
  gradientId: string;
  lineColor: string;
  lineWidth: number;
  opacity?: number;
};

export const TimeSeriesAreaPaths = ({
  areaPath,
  linePath,
  gradientId,
  lineColor,
  lineWidth,
  opacity,
}: TimeSeriesAreaPathsProps) => (
  <g opacity={opacity}>
    <path d={areaPath} fill={`url(#${gradientId})`} />
    <path
      d={linePath}
      fill="none"
      stroke={lineColor}
      strokeWidth={lineWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
);
